import { SocialMedia } from 'components/common/SocialMedia'
import { FaCircle, FaInfoCircle } from 'react-icons/fa'
import s from './Title.scss'
import { UncontrolledTooltip } from 'reactstrap'

const Title = ({
  name,
  legalName,
  facebook,
  twitter,
  linkedin,
  instagram,
  youtube,
  breadCrumb
}) => (
  <section className={s.contactMain}>
    <div className={s.title}>
      <div className={s.userInfo}>
        <h4>{name}</h4>
        <FaCircle className={s.circle} />
        <div className={s.socialMediaContainer}>
          <SocialMedia
            facebook={facebook}
            twitter={twitter}
            linkedin={linkedin}
            instagram={instagram}
            youtube={youtube}
          />
        </div>
        <p style={{ marginBottom: 0, fontSize: 14, color: '#007bff' }}>
          {breadCrumb}
          <FaInfoCircle id="Type1" style={{ marginLeft: 5 }} />
          <UncontrolledTooltip placement="top" target="Type1">
            This is the email address of your company. Emails sent to this email address will be
            saved under the company notes
          </UncontrolledTooltip>
        </p>
      </div>
      {legalName && <div className={s.companyInfo}>Legal Name: {legalName}</div>}
    </div>
  </section>
)

export default Title
